var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("../assets/img/no-auth.png"),"alt":""}}),_c('div',[_c('h1',[_vm._v("很抱歉，您没有权限访问！")]),_c('p',{staticClass:"btn-primary",on:{"click":_vm.gotoOut}},[_vm._v("退出")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }